<template>
    <!-- // ***************************************************** -->
    <!-- // ***************** CHECK LIST ************************ -->
    <v-container grid-list-md fluid>
        <v-row class="d-flex justify-space-between mb-1">
            <v-col cols="6" class="d-flex flex-column">
                <v-row no-gutters>
                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-btn-back @click="$router.push({ name: 'auditReport' })" />
                    </v-col>
                    <v-col cols="11" class="d-flex align-center">
                        <h2>Charges supérieures à 500&#x20ac; HT</h2>
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-btn-icon
                                    v-bind="props"
                                    size="large"
                                    class="ml-2"
                                    icon="$oss-help"
                                />
                            </template>

                            <p class="mb-0">
                                Compte d'attente 600000 et comptes 606 (sauf 6061) ou 615 -
                                Uniquement si validées
                            </p>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="1" />
                    <v-col cols="10">
                        {{ `Statut : ${checkStatus}` }}
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6">
                <v-row no-gutters class="d-flex justify-end align-center">
                    <!-- ** upload -->
                    <v-tooltip location="bottom" text="Lier un document">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="dialogAuditCheckDocumentsManager = true"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-upload"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>

                    <!-- ** chat -->
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="openChat = !openChat"
                                v-bind="props"
                                class="btn"
                                size="x-small"
                                icon="$oss-chat"
                            >
                            </v-btn>
                        </template>
                        <span>Message</span>
                    </v-tooltip>

                    <!-- ** store -->
                    <v-btn
                        :disabled="
                            closedPeriod || validated || loading || dataLoading || !accountingPeriod
                        "
                        @click="storeComments()"
                        size="small"
                        class="mx-1"
                    >
                        Enregistrer
                    </v-btn>

                    <!-- ** validate -->
                    <v-btn
                        :disabled="
                            closedPeriod ||
                            loading ||
                            dataLoading ||
                            !accountingPeriod ||
                            some600000
                        "
                        @click="validateFunction()"
                        data-cy="CheckPurchasesOver500-valid"
                        size="small"
                        class="mx-1"
                    >
                        {{ validated ? "Invalider" : "Valider" }}
                    </v-btn>

                    <template v-if="isEnableReview">
                        <div
                            style="
                                border-right: 2px solid black;
                                width: 2px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />

                        <v-icon
                            :disabled="
                                reviewed === 1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-up"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = 1;
                                storeComments('REVIEW');
                            "
                        />
                        <v-icon
                            :disabled="
                                reviewed === -1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-down"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = -1;
                                storeComments('REVIEW');
                            "
                        />

                        <div
                            style="
                                border-right: 2px solid black;
                                width: 1px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />
                    </template>

                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-prev
                                v-bind="props"
                                :disabled="!previousControl"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToPreviousControl();
                                "
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle précédent :
                            {{
                                previousControl && previousControl.title
                                    ? previousControl.title
                                    : ""
                            }}
                        </div>
                    </v-tooltip>

                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-next
                                v-bind="props"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToNextControl();
                                "
                                :disabled="!nextControl"
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle suivant :
                            {{ nextControl && nextControl.title ? nextControl.title : "" }}
                        </div>
                    </v-tooltip>
                    <div
                        style="
                            border-right: 2px solid black;
                            width: 1px;
                            height: 25px;
                            margin: 0 4px;
                        "
                    />
                    <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon="$dots_vertical"
                                v-bind="props"
                                class="mx-1"
                                color="secondary"
                            />
                        </template>
                        <v-list nav>
                            <v-list-item
                                v-if="auditCheckResult && auditCheckResult.id"
                                @click="deleteAuditCheckResult(auditCheckResult.id)"
                                :title="`Supprimer les commentaires et la validation du contrôle`"
                            >
                                <template #append>
                                    <v-tooltip
                                        location="bottom"
                                        text="Chaque ligne comptable a son bouton de suppression"
                                    >
                                        <template v-slot:activator="{ props }">
                                            <v-icon v-bind="props" size="small" icon="$oss-trash" />
                                        </template>
                                    </v-tooltip>
                                </template>
                            </v-list-item>

                            <v-list-item @click="displayActivityDialog = true">
                                <v-list-item-title>Afficher l'activité</v-list-item-title>
                                <template v-slot:append>
                                    <v-icon>$oss-activity</v-icon>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-row>
            </v-col>
        </v-row>
        <div
            style="
                height: calc(100vh - 157px);
                overflow-y: auto;
                border-top-left-radius: 25px;
                border-top-right-radius: 25px;
            "
        >
            <template v-if="loading || dataLoading">
                <v-card
                    elevation="0"
                    style="background-color: #ffffff; border-radius: 25px; margin-top: 10px"
                >
                    <v-card-title class="pa-4 d-flex justify-center">
                        <v-progress-circular indeterminate class="mr-3" />
                    </v-card-title>
                </v-card>
            </template>
            <template v-else-if="!accountingPeriod">
                <v-row no-gutters class="d-flex flex-column justify-center align-center mb-3">
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Aucune période sélectionnée</h3>
                </v-row>
            </template>

            <template v-else>
                <v-row
                    no-gutters
                    v-if="closedPeriod"
                    class="d-flex flex-column justify-center align-center mb-3"
                >
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Période clôturée</h3>
                </v-row>
                <v-row no-gutters v-else-if="!accountingLines.length">
                    <v-col cols="12" class="d-flex justify-center mb-3">
                        <h3>Aucun achat identifié sur la période sélectionnée</h3>
                    </v-col>
                </v-row>

                <v-card
                    v-if="accountingLines.length"
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="px-6 pb-6 pt-0 mt-4"
                >
                    <v-card-title class="px-0 py-2">
                        <v-switch
                            v-model="hideIgnored"
                            :label="`Cacher les achats ignorés`"
                            style="text-center"
                            class="ml-2"
                            data-cy="CheckPurchasesOver500-achatsIgnores"
                        />
                    </v-card-title>

                    <v-card-text class="pa-0">
                        <v-data-table
                            :headers="purchasesOver500Headers"
                            :items="alsIgnoreACRFilter"
                            multi-sort
                            :loading="loading"
                            class="table"
                            style="border: 1px #ededed solid"
                        >
                            <template #no-data>Aucune anomalie</template>

                            <template v-slot:item="props">
                                <tr>
                                    <!-- // ** date -->
                                    <td v-if="props.item.date">
                                        {{ formatDate(props.item.date) }}
                                    </td>
                                    <td v-else>-</td>

                                    <!-- // ** supplier -->
                                    <td
                                        v-if="
                                            props.item.thirdPartyCompany &&
                                            props.item.thirdPartyCompany.name
                                        "
                                    >
                                        {{ props.item.thirdPartyCompany.name }}
                                    </td>
                                    <td v-else>-</td>

                                    <!-- // ** invoiceNumber -->
                                    <td
                                        v-if="props.item.object && props.item.object.invoiceNumber"
                                        class="text-left"
                                    >
                                        {{ props.item.object.invoiceNumber }}
                                    </td>
                                    <td v-else>-</td>

                                    <!-- // ** wording -->
                                    <td v-if="props.item.wording">
                                        {{ props.item.wording }}
                                    </td>
                                    <td v-else />

                                    <!-- // ** accountableAccount.name -->
                                    <td
                                        v-if="
                                            props.item.accountableAccount &&
                                            props.item.accountableAccount.name
                                        "
                                        class="text-center"
                                    >
                                        <span
                                            :style="accAccColor(props.item.accountableAccount.name)"
                                            >{{ props.item.accountableAccount.name }}</span
                                        >
                                    </td>
                                    <td v-else />

                                    <!-- // ** amountSigned -->
                                    <td v-if="props.item.amountSigned" class="text-right">
                                        {{
                                            newCommonFormatCurrency(
                                                props.item.amountSigned,
                                                undefined,
                                            )
                                        }}
                                    </td>
                                    <td v-else />

                                    <!-- // ** ICON : DIALOG - NEW FIXEDASSET  -->
                                    <td class="text-center pl-2 py-0">
                                        <v-btn-icon
                                            icon="$remove_red_eye"
                                            color="primary"
                                            @click="openObject(props.item)"
                                            size="default"
                                        />
                                    </td>

                                    <!-- // ** Ignorer ( laisser en c/6 ) -->
                                    <td
                                        v-if="
                                            props.item.auditCheckResults &&
                                            props.item.auditCheckResults.length &&
                                            props.item.auditCheckResults[0].status &&
                                            props.item.auditCheckResults[0].status === 'IGNORE'
                                        "
                                        class="text-center pl-2 py-0"
                                    >
                                        <v-btn-trash
                                            v-if="
                                                props.item.auditCheckResults &&
                                                props.item.auditCheckResults[0] &&
                                                props.item.auditCheckResults[0].id
                                            "
                                            @click="
                                                deleteAuditCheckResult(
                                                    props.item.auditCheckResults[0].id,
                                                )
                                            "
                                            size="x-small"
                                        />
                                    </td>
                                    <td v-else class="text-center pl-2 py-0">
                                        <v-btn-icon
                                            icon="$close"
                                            size="default"
                                            color="primary"
                                            :disabled="
                                                disabledIgnoreBtn(
                                                    props.item.accountableAccount.name,
                                                )
                                            "
                                            @click="ignoreObject(props.item)"
                                        />
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>

                <!-- // ** connectedDocuments -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrDocuments
                        :connectedDocuments="connectedDocuments"
                        :companyId="companyId"
                        :acKey="acKey"
                        :auditCheckResult="auditCheckResult || {}"
                        :accountingPeriodId="accountingPeriodId || undefined"
                        @unlinkedDocument="unlinkDocument($event)"
                        @showLinkedDocument="showLinkedDocument($event)"
                    />
                </template>

                <!-- // ** results -->
                <!-- // ** this control don't generate results -->
                <!-- <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrResults
                        :results="results"
                        :companyId="companyId"
                    ></AuditConnectedAcrResults>
                </template> -->

                <!-- // ++ longComment -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires détaillés</h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <!-- // ** icons *************** -->
                        <v-col cols="1" class="d-flex align-center justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>

                                <!-- // ** expand icon -->
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            longCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        data-cy="CheckPurchasesOver500-commentaireDetailles"
                                        @click="longCommentExpand = !longCommentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-if="longCommentExpand" transition="longCommentExpand">
                        <!-- <v-expand-transition no-gutters v-show="longCommentExpand"> -->
                        <v-card-text class="px-4">
                            <v-textarea
                                v-model="longComment"
                                :disabled="closedPeriod || validated"
                                auto-grow
                                style="border: 1px #ededed solid"
                                outlined
                            />
                        </v-card-text>

                        <v-row>
                            <v-col style="padding-bottom: 0">
                                <v-card-title
                                    style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                                    class="d-flex justify-end"
                                >
                                    <v-spacer />

                                    <!-- // ** Store data -->
                                    <v-btn
                                        :disabled="closedPeriod || validated"
                                        rounded
                                        class="btn btn_blue"
                                        @click.stop="storeComments()"
                                        size="small"
                                    >
                                        Enregistrer les commentaires
                                    </v-btn>
                                </v-card-title>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- // ++ shortComment -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <!-- // ** title ************** -->
                        <!-- <v-col cols="11" class="subtitle-2"> -->
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires synthétiques</h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <!-- // ** icons *************** -->
                        <v-col cols="1" class="d-flex align-center justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>

                                <!-- // ** expand icon -->
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            shortCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        data-cy="CheckPurchasesOver500-commentaireSynthétiques"
                                        @click="shortCommentExpand = !shortCommentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-if="shortCommentExpand" transition="shortCommentExpand">
                        <v-card-text class="px-4">
                            <v-textarea
                                v-model="shortComment"
                                :disabled="closedPeriod || validated"
                                auto-grow
                                style="border: 1px #ededed solid"
                                outlined
                            />
                        </v-card-text>

                        <v-row>
                            <v-col style="padding-bottom: 0">
                                <v-card-title
                                    style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                                    class="d-flex justify-end"
                                >
                                    <v-spacer />

                                    <!-- // ** Store data -->
                                    <v-btn
                                        v-if="closedPeriod || validated"
                                        disabled
                                        rounded
                                        class="btn btn_blue"
                                        size="small"
                                    >
                                        Enregistrer les commentaires
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue"
                                        @click.stop="storeComments()"
                                        size="small"
                                    >
                                        Enregistrer les commentaires
                                    </v-btn>
                                </v-card-title>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- // ** GeneralLedger -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Grand livre c/600000 et 606 (sauf 6061) ou 615</h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <!-- // ** icons *************** -->
                        <v-col cols="1" class="d-flex align-center justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center">
                                    <!-- <v-icon v-if="validated" color="primary"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>

                                <!-- // ** expand icon -->
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            generalLedgerExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="generalLedgerExpand = !generalLedgerExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-show="generalLedgerExpand" transition="expand">
                        <!-- // // switchs generalLedger -->

                        <v-row>
                            <v-col>
                                <GeneralLedger
                                    ref="generalLedger"
                                    :companyId="companyId"
                                    :accountingPeriodId="accountingPeriod.id"
                                    :accountableAccountFilter="auditItems.accountableAccounts || []"
                                    :excludedAccountableAccountFilter="
                                        auditItems.excludedAccountableAccounts || []
                                    "
                                    :inNm1="false"
                                    @query-done="onQueryDone"
                                    :enableAuditedAccountableAccounts="true"
                                />
                                <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                            </v-col>
                        </v-row>

                        <!-- // ** OD -->
                        <!-- // needs import of AccountingItemEdition2 -->
                        <!-- // look in CheckCapitalChanges.vue -->
                        <!-- <v-row>
                                    <v-col style="padding-bottom: 0">
                                        <v-card-title style="padding-top: 20px; padding-bottom: 0; padding-left: 0;">

                                            <v-spacer></v-spacer>

                                            <v-btn
                                                v-if="(accountingPeriod && accountingPeriod.closed)"
                                                rounded
                                                small
                                                disabled
                                            >
                                                OD
                                            </v-btn>
                                            <v-btn
                                                v-else
                                                rounded
                                                small
                                                dark
                                                color="primary"
                                                class="btn btn_blue"
                                                @click="validateCapitalChanges();miscellanousOperationData = undefined;miscellaneousOperationDialog=true;"
                                            >
                                                OD
                                            </v-btn>
                                        </v-card-title>
                                    </v-col>
                                </v-row> -->
                    </v-card-text>
                </v-card>

                <oss-dialog
                    v-model="displayActivityDialog"
                    v-if="displayActivityDialog"
                    title="Activité"
                    valid-title="Fermer"
                    @valid="displayActivityDialog = false"
                    @close="displayActivityDialog = false"
                    min-width="60vw"
                >
                    <UsersActivitiesHistory
                        :auditCheckKey="acKey"
                        :accountingPeriodId="accountingPeriodId"
                    >
                    </UsersActivitiesHistory>
                </oss-dialog>
                <Chat
                    :auditCheckAccountingPeriodKey="chatId"
                    v-if="openChat"
                    v-bind:chatTitle="'Chat'"
                />
                <AuditCheckDocumentsManager
                    v-model="dialogAuditCheckDocumentsManager"
                    v-if="dialogAuditCheckDocumentsManager"
                    :disabled="loading || dataLoading || !accountingPeriod"
                    :companyId="companyId"
                    :documentToDisplay="documentToDisplay"
                    :connectedDocuments="connectedDocuments || []"
                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult || {}"
                    :accountingPeriodId="accountingPeriodId || undefined"
                    :alreadyLinkedDoc="alreadyLinkedDoc"
                    @upsertedAuditCheckResult="upsertedACR"
                    @resetDialogData="
                        alreadyLinkedDoc = false;
                        documentToDisplay = {};
                    "
                />
            </template>
        </div>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Apollo } from "@/decorators";
import { isEmpty } from "lodash";

import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { closedPeriod, formatConnectedDocuments } from "../../services/audit/AuditServices";

// //////////////////// APOLLO ////////////////////////
import AUDIT_ITEMS from "../../graphql/audit/AuditItems.gql";
import DELETE_AUDIT_CHECK_RESULT_AND_RESULTS from "../../graphql/audit/DeleteAuditCheckResultId.gql";
import UPSERT_AUDIT_CHECK_RESULT from "../../graphql/audit/UpsertAuditCheckResultClosure.gql";
import UPSERT_AUDIT_CHECK_RESULT__CONNECT_EXISTING_DOCUMENT from "../../graphql/audit/UpsertAuditCheckResultConnectExistingDocument.gql";

import { Component, Prop, toNative } from "vue-facing-decorator";
import AccountableAccountVue from "../AccountableAccount.vue";
import Chat from "../chat/Chat.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import AuditCheckDocumentsManager from "./AuditCheckDocumentsManager.vue";
import AuditConnectedAcrDocuments from "./AuditConnectedAcrDocuments.vue";
import { CheckBase } from "./CheckBase";

import { isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";
import GeneralLedger from "../GeneralLedger2.vue";
// import AuditConnectedAcrResults from "./AuditConnectedAcrResults.vue"

@Component({
    components: {
        AccountableAccountVue,
        AuditCheckDocumentsManager,
        AuditConnectedAcrDocuments,
        Chat,
        UsersActivitiesHistory,
        GeneralLedger,
        // AuditConnectedAcrResults
    },
})
export class CheckPurchasesOver500 extends CheckBase {
    @Prop({ type: Boolean }) readonly active!: Boolean;
    @Prop({ default: "" }) documentId: string;

    loading: boolean = false;
    dataLoading: boolean = true;
    show: boolean = false;
    dialog: boolean = false;
    dialogAuditCheckDocumentsManager: boolean = false;
    hideIgnored: boolean = false;

    validated: boolean = false;

    company: any = {};

    // auditCheckKey: string = "8Jq55Zv3ZGm78Q8TetSZWEvO7"

    auditCheckResultId: string = "";
    auditCheckResult: any = null;

    alDocuments: Array<any> = [];
    changingDocument: any = {};
    indexOfChangingDocument: number = 0;
    changingAL: any = {};
    changingALs: Array<any> = [];
    changingAA: any = {}; // ** to drop ?
    aa6ALs: Array<any> = [];
    foundedSNAs: Array<any> = [];
    sourceToPush: any = {};

    documents: Array<any> = [];
    connectedDocuments: Array<any> = [];
    results: Array<any> = [];
    documentToDisplay: any = {};

    longCommentExpand: boolean = false;
    shortCommentExpand: boolean = false;
    generalLedgerExpand: boolean = false;

    longComment: string = "";
    shortComment: string = "";

    amount: number = 0;
    vatOrNot: string = "";

    showGenerateTableBtn: boolean = true;
    showGeneralLedgerCard: boolean = true;

    alreadyLinkedDoc: boolean = false;

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get checkStatus() {
        if (this.validated && this.reviewed === 1) {
            return "Validé par le responsable";
        }
        if (this.validated && this.reviewed === -1) {
            return "Refusé par le responsable";
        }
        if (this.validated && this.reviewed === 0) {
            return "En attente de validation par le responsable";
        }
        if (!this.validated && !this.auditCheckResult) {
            return "A faire";
        }
        if (!this.validated && this.auditCheckResult) {
            return "En cours";
        }
        return "statut manquant";
    }

    formatDate(date: string) {
        return moment(date).format("DD/MM/YYYY");
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    // ++++++++++++ CHECK HEADERS - MISSING SALES-INVOICES +++++++++

    beforeMount() {
        this._mounted();
        this.searchAccountingPeriod();
    }

    // ***********************************************************
    // ********** APOLLO - INVOICES LIST - NETAMOUNT OVER 500€ ***
    @Apollo({
        query: AUDIT_ITEMS,
        variables() {
            return {
                companyId: this.companyId,
                auditCheckKey: this.acKey,
                accountingPeriodId: this.accountingPeriodId,
                // accountingPeriodId: this.accountingPeriodId || undefined
            };
        },
        skip() {
            return !this.companyId || !this.accountingPeriodId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.dataLoading = true;

                if (data?.auditItems?.items?.[0]) {
                    this.auditItems = data.auditItems.items[0];

                    this.errMessages = this.auditItems.errMessages || [];

                    this.accountingLines = this.auditItems.accountingLines || [];

                    this.purchasesOver500Headers = this.auditItems.purchasesOver500Headers || [];
                    this.purchasesOver500Headers.forEach((element) => {
                        element.title = element.text;
                    });

                    this.company = this.auditItems.company || {};

                    this.vatOrNot =
                        this.auditItems.vatSystem && isNotSubjectToVAT(this.auditItems.vatSystem)
                            ? "TTC"
                            : "HT";

                    this.amount = this.auditItems.amount || 0;

                    if (!isEmpty(this.auditItems.commentsACR)) {
                        this.commentsACR = this.auditItems.commentsACR;
                        this.commentsACRId = this.auditItems.commentsACR.id;

                        this.auditCheckResult = this.commentsACR;

                        if (this.auditCheckResult.documents) {
                            this.connectedDocuments = this.auditCheckResult.documents;
                        }

                        if (this.auditCheckResult.results) {
                            this.results = this.auditCheckResult.results;
                        }

                        if (this.auditCheckResult.reviewed) {
                            this.reviewed = this.auditCheckResult.reviewed;
                        }

                        if (this.commentsACR?.data?.[0])
                            this.longComment = this.commentsACR.data[0]?.longComment || "";

                        this.shortComment = this.commentsACR.data[0]?.shortComment || "";

                        this.validated = this.commentsACR.data[0]?.validated || false;
                    } else {
                        this.commentsACRId = "";
                        this.longComment = "";
                        this.shortComment = "";
                        this.validated = false;
                    }
                } else {
                    this.accountingLines = [];
                }
                this.dataLoading = false;
            }
        },
    })
    auditItems: any = {};

    errMessages: Array<any> = [];

    accountingLines: Array<any> = [];

    purchasesOver500Headers: Array<any> = [];

    previousDocumentsIds: Array<any> = [];

    commentsACRId: string = "";

    reviewed: number = 0;

    // **************** ICON : DOCUMENT VIEW *****************
    openObject(al) {
        if (al.object.objectType === "document") {
            this.$router.push({
                name: "document",
                params: {
                    companyId: this.selectedCompany.id,
                    id: al.object.id,
                },
            });
        } else if (al.object.objectType === "bankTransaction") {
            this.$router.push({
                name: "reconciliation",
                params: {
                    companyId: this.selectedCompany.id,
                    bankTransactionId: al.object.id,
                },
            });
        } else {
            debugger;
        }
    }

    async ignoreObject(al) {
        const auditCheckResults = al.object.auditCheckResults;
        const acr500 =
            auditCheckResults && auditCheckResults.length
                ? auditCheckResults.find((acr) => acr.auditCheck.key === this.acKey)
                : undefined;

        let thirdPartyCompanyId = "";

        const accountingLines = al.object.accountingLines;
        if (accountingLines && accountingLines.length) {
            const tpc = accountingLines.find(
                (al) => al.thirdPartyCompany && al.thirdPartyCompany.id,
            );
            if (tpc) {
                thirdPartyCompanyId = tpc.id;
            }
        }

        // ++ IMPORTANT :
        // // ERIC : don't works if defined
        // ** differents variables, for diffenciate create and update
        // ** for:
        // ** accountingPeriod + thirdPartyCompany + document + bankTransaction
        const auditCheckResultVariables: any = {
            id: acr500 && acr500.id ? acr500.id : "",
            key: acr500 && acr500.key ? acr500.key : this.acKey + "_" + al.object.id,
            companyId: this.selectedCompany.id,
            status: "IGNORE",
            thirdPartyCompanyCreate:
                al.object && al.object.thirdPartyCompany && al.object.thirdPartyCompany.id
                    ? { connect: { id: al.object.thirdPartyCompany.id } }
                    : undefined,
            thirdPartyCompanyUpdate:
                al.object && al.object.thirdPartyCompany && al.object.thirdPartyCompany.id
                    ? { connect: { id: al.object.thirdPartyCompany.id } }
                    : undefined,
            accountingPeriodCreate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            accountingPeriodUpdate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            accountingLineCreateConnection: { connect: { id: al.id } },
            accountingLineUpdateConnection: { connect: { id: al.id } },
            // documentCreateConnection: al.object.objectType === "document" ? {connect:{ id:al.object.id}} : undefined,
            // documentUpdateConnection: al.object.objectType === "document" ? {connect:{ id:al.object.id}} : undefined,
            // bankTransactionCreateConnection: al.object.objectType === "bankTransaction" ? {connect:{ id:al.object.id}} : undefined,
            // bankTransactionUpdateConnection: al.object.objectType === "bankTransaction" ? {connect:{ id:al.object.id}} : undefined,
            // deleteDocuments: [], // ** previous results, if to delete
            // documents: [],  // ** results = générés par le contrôle
            connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
            auditCheckKey: this.acKey,
            data: [],
        };

        if (auditCheckResultVariables) {
            await this.$apollo.mutate({
                mutation: UPSERT_AUDIT_CHECK_RESULT__CONNECT_EXISTING_DOCUMENT,
                variables: auditCheckResultVariables,
            });
        }

        this.refresh();

        this.alDocuments = [];
        this.changingDocument = {};
        this.changingAL = {};
        this.changingAA = {};
        this.documents = [];
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.auditItems) {
            this.$apollo.queries.auditItems.refetch();
        } else {
            // eslint-disable-next-line
            debugger;
        }
    }

    upsertedACR() {
        this.refresh();
    }

    unlinkDocument(id) {
        this.connectedDocuments = this.connectedDocuments.filter((document) => document.id !== id);
    }

    showLinkedDocument(id) {
        this.documentToDisplay = { id };
        this.alreadyLinkedDoc = true;
        this.dialogAuditCheckDocumentsManager = true;
    }

    async storeComments(action = undefined) {
        const commentsACRKey = this.acKey + "_" + this.companyId + "_" + this.accountingPeriodId;

        const data = [
            {
                shortComment: this.shortComment || "",
                longComment: this.longComment || "",
                validated: this.validated || false,
            },
        ];

        const upsertVariables: any = {
            id: this.commentsACRId || "",
            key: commentsACRKey,
            companyId: this.companyId,
            status: this.validated ? "VALIDATED" : "EDITION",
            thirdPartyCompanyCreate: undefined,
            thirdPartyCompanyUpdate: undefined,
            accountingPeriodCreate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            accountingPeriodUpdate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            // deleteDocuments: [], // ** previous results, if to delete
            // documents: [],  // ** results = générés par le contrôle
            connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
            auditCheckKey: this.acKey,
            data: data,
            type: "IN_AUDIT_REPORT",
            reviewed: this.reviewed,
        };

        // eslint-disable-next-line no-await-in-loop
        const resultUnrecoverableLoss: any = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT,
            variables: upsertVariables,
        });

        // await this.createUserActivity(action) // deprecated

        this.refresh();
    }

    async validateFunction() {
        if (!this.validated) {
            this.validated = !this.validated;
            await this.storeComments("VALIDATE");
        } else {
            this.validated = !this.validated;
            this.reviewed = 0;
            await this.storeComments("UPDATE");
        }
    }

    // ***************** DELETE ACR **********************
    async deleteAuditCheckResult(acrId) {
        const deletedACR = await this.$apollo.mutate({
            mutation: DELETE_AUDIT_CHECK_RESULT_AND_RESULTS,
            variables: { id: acrId },
        });

        // await this.createUserActivity("DELETE") // deprecated

        if (deletedACR) {
            this.refresh();
        }
    }

    get alsIgnoreACRFilter(): any {
        const filtereALs = this.accountingLines.filter(
            (al) =>
                !al.auditCheckResults ||
                !al.auditCheckResults[0] ||
                !al.auditCheckResults[0].status ||
                al.auditCheckResults[0].status !== "IGNORE",
        );

        if (this.hideIgnored === false) {
            return this.accountingLines;
        }

        this.hideIgnored = true;
        return filtereALs;
    }

    get closedPeriod() {
        if (this.accountingPeriod) {
            return closedPeriod(this.accountingPeriod);
        }
    }

    get some600000() {
        if (this.accountingLines) {
            return this.accountingLines.some((al) =>
                al.accountableAccount?.name?.startsWith("600000"),
            );
        }
        return false;
    }

    accAccColor(accountableAccountName) {
        if (accountableAccountName === "600000") {
            return { color: "red" };
        }
        return {};
    }

    disabledIgnoreBtn(accountableAccountName) {
        if (accountableAccountName === "600000") {
            return true;
        }
        return false;
    }

    onQueryDone(data) {
        if (!data.generalLedger?.length) {
            this.showGeneralLedgerCard = false;
        } else {
            this.showGeneralLedgerCard = true;
        }
    }
}

export default toNative(CheckPurchasesOver500);
</script>
